export enum Page {
  Dashboard = 'dashboard',
  Calendar = 'calendar',
  Availability = 'availability',
  Menus = 'menus',
  Reports = 'reports',
}

export const ROUTES = {
  [Page.Dashboard]: '/dashboard',
  [Page.Calendar]: '/calendar',
  [Page.Availability]: '/availability',
  [Page.Menus]: '/menus',
  [Page.Reports]: '/report/:reportName',
  root: '/',
  login: '/login',
  logout: '/logout',
  authComplete: '/auth-complete',
  manifests: '/vendor/manifests',
  forgotPasswordEmail: '/forgot_password/email',
  forgotPasswordReset: '/forgot_password/password',
} as const;
